export const displayElementMiddleware = next => ({ directive, meta }) => {

  if (directive.show) {
    return next({ directive: { ...directive, call: () => document.querySelector(directive.show).style.display = 'inline-block' }, meta });
  }

  if (directive.hide) {
    return next({ directive: { ...directive, call: () => document.querySelector(directive.hide).style.display = 'none' }, meta });
  }

  return next({ directive, meta });;
};
